var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    viewBox: "0 0 52 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2516 0.218018L41.2189 5.78186L46.7827 8.74928L41.2189 11.7167L38.2516 17.2805L35.284 11.7167L29.7202 8.74928L35.284 5.78186L38.2516 0.218018ZM18.0015 7.24927L24.0014 18.4993L35.2514 24.4993L24.0014 30.4992L18.0015 41.7492L12.0015 30.4992L0.751465 24.4993L12.0015 18.4993L18.0015 7.24927ZM44.2514 34.2492L40.5016 27.218L36.7515 34.2492L29.7202 37.9993L36.7515 41.7492L40.5016 48.7804L44.2514 41.7492L51.2827 37.9993L44.2514 34.2492Z",
    fill: "#207DF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.c0772071e9b433946058afef83fdf603.svg";
export { ForwardRef as ReactComponent };